import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getApi, postApi } from '../service/service';
import { API_URL } from '../config';
import CircularLoader from '../components/common/loader/loader';
import MetaDecorator from '../components/common/loader/metaDecorator';
import { toast } from '../utils/toast';
import { getToken, getUserLoginName, getUserRole } from '../utils/auth';
import imgUrl from '../images/satsang.jpg';

class Jivni extends Component {
  state = {
    value: '',
    isloading: true,
    satsang: null,
  };

  componentDidMount() {
    this.getSatsang(`${API_URL}/satsang/${this.getId()}`);
  }

  getId = () => {
    return this.props.match.params.id;
  };

  getSatsang = (apiUrl) => {
    const token = getToken();
    let header = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    getApi(apiUrl, header).then((response) => {
      // Backend returns { status: true, data: [...] }
      const data = response.data || response;
      this.setState({ isloading: false, satsang: Array.isArray(data) ? data : [] });
    }).catch((error) => {
      this.setState({ isloading: false, satsang: [] });
      const errorMessage = error.message || error.msg || 'Failed to load satsang. Please try again.';
      toast.error(errorMessage);
    });
  };

  removeSatsang = (id) => {
    // First get the satsang data to preserve all fields
    const token = getToken();
    const userloginname = getUserLoginName();
    let header = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    getApi(`${API_URL}/satsang/${id}`, header).then((response) => {
      // Backend returns { status: true, data: [...] }
      const data = response.data || response;
      if (data && Array.isArray(data) && data.length) {
        // Use update API to set isDeleted: true
        let updateHeader = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          updateBody = {
            id: id,
            name: data[0].name,
            description: data[0].description,
            user: userloginname,
            category: data[0].category,
            isDeleted: true,
          };
        postApi(`${API_URL}/satsang/addUpdate`, updateHeader, updateBody).then((result) => {
          if (result.status || result.success) {
            toast.success('Satsang removed successfully!');
            const { history } = this.props;
            // Redirect to archive page after soft delete
            history.push('/archive');
          } else {
            // Backend uses 'msg' field for errors
            const errorMessage = result.msg || result.message || result.error || 'Failed to remove satsang. Please try again.';
            toast.error(errorMessage);
          }
        }).catch((error) => {
          const errorMessage = error.message || error.msg || 'An error occurred. Please try again.';
          toast.error(errorMessage);
          
          // If unauthorized, redirect to login
          if (error.statusCode === 401 || error.statusCode === 403) {
            const { history } = this.props;
            history.push('/login');
          }
        });
      } else {
        toast.error('Satsang not found or you do not have permission to view it.');
      }
    }).catch((error) => {
      const errorMessage = error.message || error.msg || 'Failed to fetch satsang data. Please try again.';
      toast.error(errorMessage);
      
      // If unauthorized, redirect to login
      if (error.statusCode === 401 || error.statusCode === 403) {
        const { history } = this.props;
        history.push('/login');
      }
    });
  };
  navigateToPage = () => {
    this.props.history.replace(`/about?${this.state.value}`);
  };
  handleChange = (evt) => {
    this.setState({ value: evt.target.value.substr(0, 100) });
  };
  render() {
    const url = this.props.match.path.split('/:id')[0];

    let customClass =
      url === '/jgd-satsang'
        ? 'satsang'
        : url === '/badela-satsang'
        ? 'badela-satsang'
        : url === '/prarthna'
        ? 'prarthna'
        : url === '/jivani'
        ? 'jumbotron'
        : 'jumbotron';

    return (
      <div style={{ backgroundColor: '', width: '100%', minHeight: '700px' }}>
        <MetaDecorator
          title="swami ji satsang"
          description="swami ji satsang desc"
          imgSrc={imgUrl}
        />

        <div className={customClass}></div>
        <div
          className="container"
          style={{
            marginTop: '3%',
            'min-height': '450px',
            'margin-bottom': '2%',
          }}
        >
          <div
            className="row"
            style={{
              border: '',
              margin: 'auto',
              width: '100%',
              padding: '0% 10%',
            }}
          >
            <div className="col-sm-12">
              {!!getUserLoginName() && (
                <div>
                  <Button
                    style={{ position: 'relative', left: '5%' }}
                    variant=""
                  >
                    <Link className="" to={`/satsang/${this.getId()}`}>
                      Update Satsang
                    </Link>
                  </Button>
                  <Button
                    style={{ position: 'relative', left: '10%' }}
                    variant="danger"
                    onClick={() => {
                      this.removeSatsang(this.getId());
                    }}
                  >
                    Remove
                  </Button>
                </div>
              )}
              <h3></h3>
              {!this.state.isloading && (
                <div className="col-sm-12 text-center title">
                  <h5>{this.state.satsang[0].name}</h5>
                </div>
              )}

              {!this.state.isloading ? (
                <div className="contents title">
                  {this.state.satsang[0].description.split('\n').map((str) => (
                    <div
                      className={str.includes('iframe') ? 'sub-content' : ''}
                      dangerouslySetInnerHTML={{ __html: str }}
                    ></div>
                  ))}
                </div>
              ) : (
                <div className="loader-container">
                  <CircularLoader />
                </div>
                // <Link to="/">Go to Home Page</Link>
              )}
              <h1></h1>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Jivni);



// WEBPACK FOOTER //
// ./src/pages/jivini.jsx